var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"downloadBtn"},[_c('div',{staticClass:"btnlist"},_vm._l((_vm.appStoreList),function(item){return _c('a',{key:item.id,attrs:{"href":item.href},on:{"click":function($event){return _vm.downloadApp(item)}}},[_c('img',{attrs:{"src":require(`../assets/download/${item.img}`)}}),_c('span',[_vm._v(_vm._s(item.name))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }